import getPropertyOptionShorthand from "./get-property-option-shorthand";
import getTriggerParameterShorthand from "./get-trigger-parameter-shorthand";

/**
 * Check for option shorthand
 * @param {String} name
 * @param {String} parameters
 * @param {Boolean} [isOption]
 * @returns {Map<"name" | "rest", String>}
 */
const getOptionShorthand = (name, parameters, isOption) => {
  /** Parameters (option values) exists, so don't look for shorthand */
  if (parameters) {
    return new Map([
      ["name", name],
      ["rest", parameters],
    ]);
  }

  if (isOption) {
    return getPropertyOptionShorthand(name);
  } else {
    return getTriggerParameterShorthand(name);
  }
};

export default getOptionShorthand;
